import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ResidentialService } from '../../questionarie-signup/questionnaire-residential/residential.service';
import {
  HttpClient,
  HttpResponse,
  HttpParams,
  HttpHeaders,
} from '@angular/common/http';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { environment } from '../../../environments/environment';
import { _ } from 'underscore';
import { Title, Meta } from '@angular/platform-browser';
import { RecommendationService } from '../../questionarie-signup/questionnaire-residential/recommendation/recommendation.service';
import 'rxjs/add/operator/pairwise';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-admin-utility-login',
  templateUrl: './admin-utility-login.component.html',
  styleUrls: ['./admin-utility-login.component.css'],
})
export class AdminUtilityLoginComponent implements OnInit {
  @Input() forgotModalVisible = false;
  userObj = {
    emailId: '',
    password: '',
    phone: '',
  };
  url = environment.api_url;
  previousUrl = '';
  url1 = '';
  oldURL = '';
  // forgotModalVisible = false;
  user_bot: boolean;
  invalidEmail = false;
  modalRef: BsModalRef;

  private loadNavigateByUrl = {
    faq: '/faq',
    precontact: '/faq/contact-us',
    privacypolicy: '/faq/privacy-policy',
    termsofservice: '/faq/terms-of-service',
    residential: '/',
    giveback: '/giveback',
    precontactmob: '/pre-contact',
    privacypolicymob: '/privacy-policy',
    termsofservicemob: '/terms-of-service',
    commercial: '/commercial',
    blog: '/blog',
  };
  @ViewChild('errorStatus4CE', { static: true }) errorStatus4CE: ElementRef;

  // horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  // verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(
    private residentialService: ResidentialService,
    private http: HttpClient,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private recommendationService: RecommendationService,
    private title: Title,
    private meta: Meta,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.activeRouter.queryParams.subscribe((params) => {
      this.previousUrl = params.returnUrl;
    });
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');

    this.title.setTitle('Login to your Honest Gorilla dashboard');

    this.meta.updateTag({
      name: 'keywords',
      content: 'login,honest gorilla,get started',
    });
    this.meta.updateTag({
      name: 'description',
      content:
        'Login to your Honest Gorilla dashboard to renew or choose a new energy plan, update your saved responses, or learn what special offers we have in store for you.',
    });
    this.meta.updateTag({ name: 'author', content: 'HonestGorilla' });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
  }

  formatPhoneNumber(phoneNo: string): string {
    return `${phoneNo.slice(0, 3)}-${phoneNo.slice(3, 6)}-${phoneNo.slice(6)}`;
  }

  // create account
  createAccount(event, myForm) {
    this.invalidEmail = false;
    if (this.userObj.emailId == '') {
      this.invalidEmail = true;
      return false;
    }
    this.validateEmailOrPhone();
    this.userObj = { ...this.userObj };
    const body = new HttpParams()
      .append('userObj', JSON.stringify(this.userObj))
      .append('a', 'login');
    this.http
      .get(this.url + '/login', { params: body })
      .subscribe((res: any) => {
        const result = res;
        if (result.statusCode === '001') {
          if (result.data.userRole === 'Admin') {
            this.title.setTitle('Admin Dashboard');
            sessionStorage.setItem('userObj', JSON.stringify(result.data));
            this.router.navigate(['hg-admin-success']);
          } else {
            this.openLoginErrorTemplate();
            this.userObj.emailId = '';
            this.userObj.password = '';
          }
        } else {
          this.openLoginErrorTemplate();
          this.userObj.emailId = '';
          this.userObj.password = '';
        }
      });
  }
  openLoginErrorTemplate() {
    const template: ElementRef<any> = this.errorStatus4CE;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }
  goToHomeClose() {
    this.modalRef.hide();
  }
  goToHome() {
    this.modalRef.hide();
    this.router.navigate(['/']);
  }

  validateEmailOrPhone() {
    if (this.userObj.emailId && this.userObj.emailId.indexOf('@') === -1) {
      this.userObj.phone = this.formatPhoneNumber(this.userObj.emailId);
      delete this.userObj.emailId;
    } else if (this.userObj.emailId.indexOf('@') > 1) {
      if (this.userObj.emailId === undefined)
        this.userObj.emailId = this.userObj.emailId;
      delete this.userObj.phone;
    }
  }

  closebtn() {
    window.history.back();
  }
  showForgotModal() {
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
    this.forgotModalVisible = true;
  }
  onClose(isVisible: boolean) {
    this.forgotModalVisible = isVisible;
  }

  toggleShowPassword(password) {
    this.user_bot = !this.user_bot;
  }

  // handling the gmail authentication flow
  getAuthenticate(url) {
    // questionarie object
    const questionnarieObj = this.residentialService.userResponse;
    const questionStatusObj = sessionStorage.getItem('questionStatusObj');
    sessionStorage.setItem('questionStatusObj', questionStatusObj);
    sessionStorage.setItem('userResponse', JSON.stringify(questionnarieObj));

    const body = new HttpParams()
      .append('a', 'external')
      .append('questionnarieObj', JSON.stringify(questionnarieObj))
      .append('type', JSON.stringify('login'));

    this.http
      .post(this.url + '/getUserResponse', body)
      .subscribe((res: any) => {
        const result = res;
        window.location.href = environment.api_url + url;
      });
  }
}
